/**
 * Format numbers for display: round floats so 79.99999999 shows as 80.
 * Returns "—" for null/undefined.
 *
 * @param {number|null|undefined} value
 * @param {number} decimals - decimal places (default 0)
 * @returns {number|string}
 */
export function formatNumber(value, decimals = 0) {
  if (value == null || value === "") return "—";
  const n = Number(value);
  if (Number.isNaN(n)) return "—";
  if (Number.isInteger(n) && decimals === 0) return n;
  const rounded = Number(n.toFixed(decimals));
  return decimals === 0 ? Math.round(rounded) : rounded;
}

export function formatWeight(value) {
  return formatNumber(value, 0);
}

export function formatReps(value) {
  return formatNumber(value, 0);
}
